const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  logFlag: state => state.app.logFlag
  // token: state => state.user.token,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js